/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import Address from "./Address";
import { SidebarGlobal } from "./_SidebarGlobal";
import MessageDialog from "./MessageDialog";
import UploadImage from "./UploadImage";
import AppActions from "./AppActions";
import ConfirmButton from "./ConfirmButton";
import L from "./Lang";
import Icon from "./Icon";
import { Pop } from './PopModal';
import { withParamsAndNavigate } from './WithParamsAndNavigate';

class OrganizationView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                address: {}
            }
        };
    }

    async componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        this.setState({ loading: true });
        if (this.props.params.id) {
            try {
                let j = await qreq.getAsync('/api/organization/get/' + this.props.params.id);
                if (j.errorCode === 0) {
                    this.setState({ item: j.item });
                    // after
                    await this.checkIfAccountExists(j.name);
                }

            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }
        this.setState({ loading: false });
    }

    checkIfAccountExists = async (name) => {
        let j = await this.getAsync('/api/account/get/name?name=' + name);
        if (j.item) {
            this.setState({ accountExists: true });
        }
    }

    submit = (e) => {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };

        if (!item.isMain)
            item.isMain = false;


        this.setState({ saving: true });


        qreq.post('/api/organization/save', item, (j) => {
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    convert = () => {
        Pop.showConfirm('Create an account from this organization?', 'Create Account', async () => {
            try {
                let j = await this.postAsync('/api/organization/transform/account', this.state.item);
                if (j.errorCode === 0) {
                    this.success('Successfully created!');
                    this.props.navigate('/account/edit/' + j.item.id);
                }
                else {
                    this.alert(j.errorMessage);
                }
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Organizations</L></h1><LoadingAlert /></div>);
        SidebarGlobal.setSubNav(<>
            <button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <span className="d-none d-md-inline"><L><L>Save</L></L></span></button>
            {!this.state.accountExists && <button type="button" className="btn btn-primary" onClick={this.convert}><FontAwesomeIcon icon={fa.faChain} /> <span className="d-none d-md-inline"><L>Create Account</L></span></button>}
        </>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Organizations</L></h1>


                <AppActions>
                    <ConfirmButton submit lg icon="faSave">
                        <L>Save</L>
                    </ConfirmButton>
                </AppActions>

                <Breadcrumb path={[['Organizations', '/organization'], [this.id ? 'Edit' : 'New']]} />
                <div className="row">
                    <div className="col-lg-8">
                        <Card title="Organization Info">
                            <FormInput model={this.state.item} name="name" label="Organization Name" type="text" required onChange={this.change} />
                            <FormInput model={this.state.item} name="isMain" label="Set this as the main organization." type="switch" onChange={this.change} />
                        </Card>
                        <Address title="Address" item={this.state.item.address} required={false} />
                        <Card title="Contact">
                            <FormInput model={this.state.item} name="phone" label="Phone" type="text" onChange={this.change} />
                            <FormInput model={this.state.item} name="fax" label="Fax" type="text" onChange={this.change} />
                            <FormInput model={this.state.item} name="email" label="E-Mail" type="email" onChange={this.change} />
                        </Card>
                        <Card title="Billing">
                            <FormInput model={this.state.item} name="npi" label="NPI" type="text" onChange={this.change} />
                            <FormInput model={this.state.item} name="tin" label="TIN" type="text" onChange={this.change} />
                            <FormInput model={this.state.item} name="ptan" label="PTAN" type="text" onChange={this.change} />
                        </Card>
                    </div>
                    <div className="col-lg-4">
                        <Card title="Logo">
                            <UploadImage fileIdent={this.state.item.logoIdent} className="text-center" onChange={photo => this.setState({ item: { ...this.state.item, logoIdent: photo.fileIdent } })} />
                        </Card>
                        <Card title="Icon ICO">
                            <UploadImage fileIdent={this.state.item.iconIdent} className="text-center" onChange={photo => this.setState({ item: { ...this.state.item, iconIdent: photo.fileIdent } })} />
                        </Card>
                        <Card title="Icon PNG">
                            <UploadImage fileIdent={this.state.item.iconPNGIdent} className="text-center" onChange={photo => this.setState({ item: { ...this.state.item, iconPNGIdent: photo.fileIdent } })} />
                        </Card>
                        <Card title="Colors">
                            <div className="row">
                                <div className="col-6">
                                    <FormInput model={this.state.item} name="primaryColor" label="Primary Color" type="color" onChange={this.change} />
                                </div>
                                <div className="col-6">
                                    <FormInput model={this.state.item} name="secondaryColor" label="Secondary Color" type="color" onChange={this.change} />
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>

                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block"><L><L>Save</L></L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(OrganizationView);